<template>
  <div class="w-full h-full relative flex">
    <div class="relative w-4/12 h-full flex flex-col justify-center items-end">
      <div
        class="w-8/10 flex justify-center flex-col items-center z-30 -mr-28 xl:-mr-72 lg:-mr-60"
      >
        <div class="relative flex items-center max-w-210 xl:max-w-162">
          <img
            class="lt-logo invisible"
            :src="`${imgPath}/latale-logo-nav.png`"
          />
        </div>
        <div class="flex items-center -mt-14 lg:max-w-400">
          <img class="title invisible" :src="`${imgPath}/slide1/title.png`" />
        </div>
        <a
          class="flex items-center -mt-16"
          href="https://www.youtube.com/watch?v=XvbrZsOjgTA"
          data-lity
        >
          <img
            class="playBtn invisible"
            :src="`${imgPath}/slide1/play_btn.png`"
          />
        </a>
        <div class="flex items-center mt-8">
          <a
            class="playFree-btn w-216 h-55 rounded-xl font-elmessiri text-xl text-soft-orange border border-soft-orange flex items-center justify-center bg-black bg-opacity-40 tracking-wide hover:text-black invisible"
            href="https://latale.papayaplay.com/latale.do?tp=download"
            target="_blank"
          >
            Play for Free
          </a>
        </div>
      </div>
    </div>
    <div class="relative w-8/12 h-full">
      <div class="character-wrapper relative w-full -ml-28 h-full xl:ml-0">
        <img
          class="characters absolute left-0 bottom-0 h-auto w-120vh invisible xl:hidden"
          :src="`${imgPath}/slide1/main_character.png`"
        />
        <img
          class="characters absolute left-0 bottom-0 h-auto w-120vh invisible hidden xl:block"
          :src="`${imgPath}/slide1/main_character_mobile.png`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-section',
  props: {
    topAnimation: Boolean,
  },
  watch: {
    topAnimation: function(newVal, oldVal) {
      //console.log('newVal', newVal);
      if (newVal) {
        this.initAnimation();
      }
    },
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
  methods: {
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_TOP_SECTION_INNER');
    },
  },
  created: function() {
    window.addEventListener('load', this.initAnimation);
  },
};
</script>

<style lang="postcss" scoped>
.playFree-btn:hover {
  background: linear-gradient(157.96deg, #feecbc 0%, #c5a576 100%);
}
</style>
